<template>
  <div>
    <b-modal
      :no-close-on-backdrop="true"
      id="modal-set-surgery-price"
      ok-only
      centered
      size="lg"
      :title="$t('surgery.set-surgery-price')"
      @ok="submitSetSurgeryPrice()"
    >
      <b-card-text>
        <b-row>
          <b-col lg="6">
            <b-form-group
              :label="$t('reception.Surgery Price')"
              label-for="Amount"
            >
              <b-form-input
                id="Amount"
                v-model="surgeryPrice.price"
                type="number"
                :placeholder="$t('reception.Surgery Price')"
              />
            </b-form-group>
          </b-col>
          <b-col lg="6">
            <b-form-group
              :label="$t('reception.Surgery Discount')"
              label-for="Amount"
            >
              <b-form-input
                id="Amount"
                v-model="surgeryPrice.surgery_discount"
                type="number"
                :placeholder="$t('reception.Surgery Discount')"
              />
            </b-form-group>
          </b-col>
          <b-col lg="12">
            <b-row v-for="(item, i) in surgeryPrice.doctors" :key="item.id">
              <b-col lg="6" class="px-2 d-flex align-items-center">
                <h3>
                  {{ $t("surgery.Doctor") }} :
                  {{ surgeryPrice.doctors[i].name }}
                </h3>
              </b-col>
              <b-col lg="6">
                <b-form-group :label="$t('reception.Doctor Discount')">
                  <b-form-input
                    v-model="surgeryPrice.doctors[i].doctor_discount"
                    type="number"
                    :placeholder="$t('reception.Doctor Discount')"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>
    <b-modal
      ref="priceModal"
      title="Set Prices"
      :ok-only="true"
      size="lg"
      centered
    >
      <div>
        <b-form-group class="mb-4">
          <template #label>
            <b class="text-primary">{{
              $t("accounting.patient_stay_price")
            }}</b>
          </template>
          <b-form-input v-model="form.price" type="number"></b-form-input>
        </b-form-group>

        <b-form-group
          v-for="(doctor, index) in form.doctors"
          :key="doctor.id"
          class="mb-2"
        >
          <template #label>
            <b class="text-primary"
              >{{ doctor.doctor_name }} - {{ $t("accounting.doctor_price") }}</b
            >
          </template>
          <b-form-input
            v-model="form.doctors[index].doctor_price"
            type="number"
          ></b-form-input>
          <input type="hidden" v-model="form.doctors[index].id" />
        </b-form-group>
      </div>
      <template #modal-footer="{}">
        <b-button
          variant="primary"
          @click="handleSubmit"
          class="m-0"
          :disabled="loading"
          ref="button"
          block
        >
          <span v-if="!loading">{{ $t("common.add") }}</span>
          <b-spinner small v-else></b-spinner>
        </b-button>
      </template>
    </b-modal>
    <b-modal
      id="modal-patient-stay"
      :title="createMode ? 'Add Patient Stay' : 'Edit Patient Stay'"
      size="lg"
      centered
      ok-only
      :no-close-on-backdrop="true"
    >
      <b-card-text>
        <b-row>
          <b-col md="12">
            <AutoComplete
              v-model="EditForm.patient_card_id"
              :label="$t('common.Patient Card')"
              :placeholder="$t('common.Patient Card')"
              param-query="patient.name"
              :serializer="(val) => val.id"
              endpoint="patientCard"
              text-title="patient.name"
              :isRelational="true"
              keyword="patient"
              :otherQuery="`filter[type]=IN,EMERGENCY&filter[is_active]=1`"
            />
          </b-col>

          <b-col md="12">
            <b-form-group label="Stay Date & Time">
              <b-form-input
                v-model="EditForm.stay_date_time"
                type="datetime-local"
              />
            </b-form-group>
          </b-col>

          <!-- <b-col md="6">
            <b-form-group label="Price">
              <b-form-input
                v-model="EditForm.price"
                type="number"
                placeholder="Price"
              />
            </b-form-group>
          </b-col> -->

          <b-col md="12">
            <b-form-group label="Doctors">
              <v-select
                v-model="EditForm.doctors"
                :options="doctors"
                multiple
                label="name"
                :reduce="(doctor) => doctor.id"
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group label="Procedure">
              <b-form-textarea
                v-model="EditForm.procedure"
                placeholder="Procedure details"
              />
            </b-form-group>
          </b-col>

          <!-- Optional Fields -->
          <b-col md="6">
            <b-form-group label="Patient Case">
              <b-form-input
                v-model="EditForm.patient_case"
                placeholder="Patient case"
              />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Diagnosis">
              <b-form-input
                v-model="EditForm.diagnosis"
                placeholder="Diagnosis"
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group label="Investigation">
              <b-form-textarea
                v-model="EditForm.investigation"
                placeholder="Investigation details"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>

      <template #modal-footer>
        <b-button
          variant="primary"
          @click="submitItem"
          :disabled="loading"
          block
        >
          <span v-if="!loading">{{ createMode ? "Add" : "Update" }}</span>
          <b-spinner small v-else></b-spinner>
        </b-button>
      </template>
    </b-modal>
    <b-card :title="$t('accounting.bed-rest-accounting')">
      <!-- Search Patient Name -->
      <div>
        <b-row class="mt-4">
          <!-- <b-col cols="12" md="12">
            <h2>{{ $t("surgery.surgery-patient-history") }}</h2>
            <br />
          </b-col> -->

          <b-col md="3" cols="12">
            <AutoComplete
              v-model="patient_card_id"
              :label="$t('common.Patient Card')"
              :placeholder="$t('common.Patient Card')"
              param-query="patient.name"
              :serializer="(val) => val.id"
              endpoint="patientCard"
              text-title="patient.name"
              :isRelational="true"
              :otherQuery="`filter[type]=IN,EMERGENCY`"
              keyword="patient"
            />
          </b-col>
          <b-col md="2" cols="12">
            <b-form-group :label="$t('common.date')" label-for="surgery_date">
              <datepicker
                id="surgery_date"
                v-model="surgery_date"
                :calendar-button="true"
                :clear-button="true"
                :bootstrap-styling="true"
                class="datebtn2"
                placeholder="YYYY-MM-DD"
              ></datepicker>
            </b-form-group>
          </b-col>
          <!-- <b-col md="2" cols="12">
              <b-form-group :label="$t('common.price')" label-for="Price">
                <b-form-input
                  id="Price"
                  type="number"
                  v-model="surgeyPrice"
                  :placeholder="$t('common.price')"
                />
              </b-form-group>
            </b-col> -->
          <b-col cols="2" class="mt-2">
            <b-button variant="primary" @click="getPatientStay()">
              {{ $t("common.search") }}
            </b-button>
          </b-col>
          <b-col cols="2" class="mt-2">
            <b-button variant="success" @click="show()">
              {{ $t("common.create") }}
            </b-button>
          </b-col>
        </b-row>

        <b-table
          :items="data"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative"
          v-if="!loading"
        >
          <template #cell(patient_card.patient.name)="data">
            <span class="text-nowrap">
              {{ getNestedProperty(data.item, "patient_card.patient.name") }}
            </span>
            <span class="text-primary"
              >({{
                data.item.patient_card.is_active == true
                  ? "Active"
                  : "Inactive"
              }})</span
            >
          </template>
          <template #cell(doctor_price)="data">
            <div class="doctor-prices text-nowrap">
              <div
                v-for="item in formatDoctorPrices(data.item.doctors_prices)"
                :key="item.id"
                class="doctor-price-item"
              >
                <div class="doctor-name">{{ item.name }}</div>
                <div class="price-details mx-1">
                  / <span class="price">{{ formatIQD(item.doctor_price) }}</span
                  >/
                  <span
                    class="status-badge"
                    :class="{
                      'status-paid': item.payment_status === 1,
                      'status-pending': item.payment_status === 0,
                    }"
                  >
                    {{ item.payment_status === 1 ? "Paid" : "Pending" }}
                  </span>
                </div>
              </div>
              <div class="total-price mt-2">
                <strong>{{ $t("accounting.total_price") }}: </strong>
                <span class="">{{
                  formatIQD(data.item.doctors_prices.total_price)
                }}</span>
              </div>
            </div>
          </template>
          <template #cell(price)="data">
            <span class="">{{ formatIQD(data.item.price) }}</span>
          </template>
          <template #cell(set_price)="data">
            <b-button
              variant="outline-primary"
              @click="openModal(data.item)"
              size="sm"
              pill
            >
              {{ $t("accounting.set-price") }}
            </b-button>
          </template>
          <template #cell(invoice)="data">
            <b-button
              v-if="data.item.patient_card.is_active == true"
              variant="outline-primary"
              @click="navigateToInvoice(data)"
              size="sm"
              pill
            >
              {{ $t("accounting.invoice") }}
            </b-button>
          </template>

          <template #cell(actions)="data">
            <b-button variant="warning" @click="show(data.item, 'edit')">
              {{ $t("common.edit") }}
            </b-button>
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner label="Loading..." />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >{{ $t("common.showing") }} 1 {{ $t("common.to") }} 10
              </span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="getPatientStay()"
            >
              <b-pagination
                v-model="page"
                :total-rows="dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BFormSelect,
  BLink,
  BFormCheckbox,
  BFormTextarea,
} from "bootstrap-vue";
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue";
import permissionChecker from "@/mixins/permissionChecker";
import vSelect from "vue-select";
import DeleteModal from "@/components/modals/DeleteModal.vue";
import ActionsButtons from "@/components/common/ActionsButtons.vue";
const AutoComplete = () => import("@/components/common/AutoComplete.vue");
import Datepicker from "vuejs-datepicker";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { useRouter } from "vue-router";

export default {
  mixins: [permissionChecker],

  components: {
    DeleteModal,
    BFormCheckbox,
    BFormTextarea,
    ActionsButtons,
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    BFormSelect,
    BLink,
    StatisticCardHorizontal,
    vSelect,
    AutoComplete,
    Datepicker,
  },
  data() {
    return {
      take: 10,
      loading: true,
      dataCount: 0,
      data: [],
      tableColumns: [
        {
          key: "patient_card.patient.name",
          sortable: true,
          label: this.$t("common.name"),
        },
        {
          key: "stay_date_time",
          sortable: true,
          label: this.$t("accounting.stay_date_time"),
          class: "text-nowrap",
        },
        // {
        //   key: "bed_number",
        //   sortable: true,
        //   label: this.$t("accounting.bed_number"),
        // },
        // { key: "price", sortable: true, label: this.$t("common.price") },
        {
          key: "price",
          sortable: true,
          label: this.$t("accounting.patient_stay_price"),
        },
        {
          key: "doctor_price",
          sortable: true,
          label: this.$t("accounting.doctor_price"),
        },
        {
          key: "set_price",
          sortable: true,
          label: this.$t("accounting.set-price-for-stay-and-patient"),
        },
        {
          key: "invoice",
          sortable: true,
          label: this.$t("accounting.invoice"),
        },
        { key: "actions", sortable: true, label: this.$t("common.actions") },
        {
          key: "created_at",
          sortable: true,
          label: this.$t("common.created_at"),
        },
      ],
      params: {
        form: {
          price: 0,
          doctors: [
            {
              id: "",
              doctor_price: 0,
            },
          ],
        },
        path: "",
      },
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: "",
      sortBy: "id",
      isSortDirDesc: true,
      page: 1,
      surgery_set_price_id: "",
      surgeryPrice: {
        price: 0,
        surgery_discount: 0,
        doctors: [
          {
            id: "",
            doctor_discount: "",
            name: "",
          },
        ],
      },
      payDoctorData: {},
      payDoctorDataPost: {
        id: "",
        doctors: { doctor_id: "", name: "", isSelected: false },
      },
      patient_card_id: null,
      form: {
        price: 0,
        doctors: [
          {
            id: "",
            doctor_price: 0,
            doctor_name: "",
          },
        ],
      },
      surgery_date: "",
      patient_card_id: "",
      surgeryName: "",
      createMode: true,
      EditForm: {
        patient_card_id: null,
        stay_date_time: "",
        procedure: "",
        doctors: [],
        price: 0,
        money_collected: 1,
        patient_case: "",
        patient_case_details: "",
        diagnosis: "",
        investigation: "",
      },
      doctors: [], // Populate this with doctors list from API
    };
  },
  mounted() {
    this.getPatientStay();
    this.getDoctors();
  },
  methods: {
    openModal(item) {
      // Initialize form with doctors and existing data if editing
      this.form = {
        price: item?.price || 0,
        doctors: item?.doctors_prices?.items.map((doctor) => ({
          id: doctor.doctor.id,
          doctor_price: doctor?.doctor_price || 0,
          doctor_name: doctor.doctor.name,
        })),
      };
      console.log(this.form);
      this.stayId = item?.id; // Store the stay ID for submission
      this.$refs.priceModal.show();
    },
    async handleSubmit() {
      // Calculate total doctor prices
      const totalDoctorPrices = this.form.doctors.reduce((sum, doctor) => {
        return sum + (Number(doctor.doctor_price) || 0);
      }, 0);

      // Validate if total doctor prices exceed main price
      if (totalDoctorPrices > this.form.price) {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Validation Error",
            variant: "danger",
            text: "Total doctor prices cannot exceed the main price",
          },
        });
        this.loading = false;
        return;
      }

      this.loading = true;
      this.form.doctors.forEach((doctor) => {
        delete doctor.doctor_name;
      });
      this.params.form = this.form;
      this.params.path = `/patient-stay/prices/${this.stayId}`;
      this.$store
        .dispatch("put", this.params)
        .then((response) => {
          this.loading = false;
          this.$refs.priceModal.hide();
          this.getPatientStay();
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Success",
              variant: "success",
              text: "Prices updated successfully",
            },
          });
        })
        .catch((error) => {
          this.loading = false;
          if (error.response.status === 400) {
            for (let item in error.response.data) {
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "Validation error",
                  variant: "danger",
                  text: error.response.data[item][0],
                },
              });
            }
          }
        });
    },
    formatDoctorPrices(item) {
      return item.items.map((doctor) => {
        console.log(doctor.doctor, "doctor.doctor.name");
        return {
          id: doctor.id,
          doctor_id: doctor.doctor_id,
          name: this.getNestedProperty(doctor, "doctor.name"),
          doctor_price: doctor.doctor_price,
          payment_status: doctor.payment_status,
        };
      });
    },
    getNestedProperty(obj, path, defaultValue = "N/A") {
      const result = path
        .split(".")
        .reduce(
          (acc, part) => (acc && acc[part] ? acc[part] : defaultValue),
          obj
        );
      // console.log("result", result);
      return result;
    },
    showModal(item) {
      this.$bvModal.show("modal-pay-doctor");
      this.payDoctorData = item;
      this.payDoctorDataPost.doctors = item.doctors.map((doctor) => {
        return { doctor_id: doctor.id, name: doctor.name, isSelected: false };
      });
    },
    async show(item, mode = "create") {
      this.createMode = mode === "create";
      if (this.createMode) {
        this.EditForm = {
          patient_card_id: null,
          stay_date_time: "",
          price: 0,
          doctors: [],
          procedure: "",
          patient_case: "",
          patient_case_details: "",
          diagnosis: "",
          investigation: "",
        };
      } else {
        this.EditForm = {
          patient_card_id: item.patient_card_id,
          stay_date_time: item.stay_date_time,
          price: item.price,
          doctors: item.doctors_prices.items.map((doctor) => doctor.doctor_id),
          procedure: item.procedure,
          patient_case: item.patient_case,
          patient_case_details: item.patient_case_details,
          diagnosis: item.diagnosis,
          investigation: item.investigation,
          id: item.id,
        };
      }
      this.$bvModal.show("modal-patient-stay");
    },
    async getDoctors() {
      await this.getList("doctor?take=100").then((response) => {
        this.doctors = response.data.data;
      });
    },
    formatDate(wantedDate) {
      const date = new Date(wantedDate);

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },

    async getPatientStay() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/patient-stay?page=${this.page}&take=${this.take}&sort=-id`;

      if (this.patient_card_id) {
        url += `&filter[patient_card_id]=${this.patient_card_id}`;
      }

      if (this.surgery_date) {
        url += `&filter[created_at]=${this.formatDate(this.surgery_date)}`;
      }
      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.loading = false;
    },
    formatIQD(value) {
      // format the value to be in IQD currency , you can use ar-IQ for arabic currency
      if (value === null) {
        value = 0;
      }
      return value.toLocaleString("en-US", {
        style: "currency",
        currency: "IQD",
      });
    },
    async submitItem() {
      this.loading = true;
      // console.log(this.EditForm.doctors);
      const payload = {
        ...this.EditForm,
        doctors: this.EditForm.doctors,
        stay_date_time: new Date(this.EditForm.stay_date_time)
          .toISOString()
          .slice(0, 16)
          .replace("T", " "),
      };
      console.log("payload", payload);
      // this.loading = false;
      // return 0;

      try {
        if (this.createMode) {
          await this.$store
            .dispatch("create", {
              form: payload,
              path: "patient-stay",
            })
            .then(async (response) => {
              this.$bvModal.hide("modal-patient-stay");
              await this.getPatientStay();
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "Success",
                  variant: "success",
                  text: "Patient stay created successfully",
                },
              });
            });
        } else {
          payload._method = "PUT";
          console.log("payload-edit", payload);
          await this.$store
            .dispatch("update", {
              form: payload,
              path: `patient-stay/${this.EditForm.id}`,
            })
            .then(async (response) => {
              this.$bvModal.hide("modal-patient-stay");
              await this.getPatientStay();
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "Success",
                  variant: "success",
                  text: "Patient stay updated successfully",
                },
              });
            });
        }

        // this.$bvModal.hide("modal-patient-stay");
        // Refresh your data list here
      } catch (error) {
        if (error.response?.status === 400) {
          for (let item in error.response.data) {
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Validation Error",
                variant: "danger",
                text: error.response.data[item][0],
              },
            });
          }
        }
      } finally {
        this.loading = false;
      }
    },
    navigateToInvoice(data) {
      this.$router.push({
        name: "patient-stay-invoice",
        params: {
          patientStayId: data.item.id,
          patientId: data.item.patient_card_id,
        },
      });
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

.doctor-prices {
  padding: 0.5rem;
}

.doctor-price-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
  border-bottom: 1px solid #eee;
}

.doctor-price-item:last-child {
  border-bottom: none;
}

.doctor-name {
  font-weight: 500;
  color: #2c3e50;
}

.price-details {
  display: flex;
  align-items: center;
  gap: 0.8rem;
}

.price {
  font-weight: 600;
  color: #27ae60;
}

.status-badge {
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.8rem;
  font-weight: 500;
  text-transform: capitalize;
}

.status-paid {
  background-color: #e8f5e9;
  color: #2e7d32;
}

.status-pending {
  background-color: #fff3e0;
  color: #f57c00;
}

.total-price {
  padding: 0.5rem;
  background-color: #f5f5f5;
  border-radius: 4px;
  text-align: right;
  font-size: 1.1rem;
  margin-top: 0.5rem;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
